import {
  NEXT_STAGE,
  PREVIOUS_STAGE,
  SUBMIT_FINAL,
  NEXT_BUTTON_UPDATE,
  SAVE_AND_EXIT_UPDATE,
  NEXT_STAGE_UPLVLRNW,
  NEXT_BUTTON_UPDATE_UPLVLRNW,
  SET_IS_COC_VALIDATION_REGION
} from '../config/constants';

export const incrementStage = () => ({
  type: NEXT_STAGE_UPLVLRNW
});
export const decrementStage = () => ({
  type: PREVIOUS_STAGE
});
export const submitFinal = () => ({
  type: SUBMIT_FINAL
});
export const saveAndExitUpdate = (bool) => ({
  type: SAVE_AND_EXIT_UPDATE,
  payload: bool
});

export const nextButtonUpdate = (bool) => ({
  type: NEXT_BUTTON_UPDATE_UPLVLRNW,
  payload: bool
});

export const setCOCValidateRegion = (bool) => ({
  type: SET_IS_COC_VALIDATION_REGION,
  payload: bool
});


